<div class="wrapper" [ngClass]="{'h-screen grid' : !show()}">
    @if(show()) {
    @if(!isViewOnly() || !id()) {
    <div class="flex flex-col h-full" [formGroup]="formGroup">
        @if(uploading()) {
        <div class="w-full flex flex-col items-center justify-center py-6">
            <p-progressSpinner ariaLabel="uploading" styleClass="mb-4"></p-progressSpinner>
            <p class="text-lg font-semibold text-gray-700">Uploading document...</p>
            <p class="text-sm text-gray-500 mt-2">Please wait while your file is being uploaded</p>
        </div>
        } @else {
        <div class="flex-1 px-5 pt-5 pb-1 space-y-2">
            <!-- Document Type Selection -->
            <div class="w-full upload-type-field">
                <p-floatLabel class="w-full upload-type-float-label">
                    <p-dropdown
                        inputId="uploadTypeId"
                        styleClass="w-full upload-type-dropdown"
                        panelStyleClass="upload-type-panel"
                        autoWidth="false"
                        [appendTo]="'body'"
                        formControlName="typeID"
                        [options]="options()"
                        optionValue="id"
                        optionLabel="description"
                        placeholder=" "
                    ></p-dropdown>
                    <label for="uploadTypeId">Type <span class="text-red-600">*</span></label>
                </p-floatLabel>
                <app-validation-feedback [control]="typeID()"
                [errors]="typeID().errors"></app-validation-feedback>

                @if(typeID().value == 7) {
                <div class="mt-4">
                    <p-floatLabel>
                        <input type="text" 
                               pInputText
                               class="w-full px-3 py-2"
                               formControlName="type"
                               required
                               placeholder="Please specify other type"
                               />
                        <label>Other Document <span class="text-red-600">*</span></label>
                    </p-floatLabel>
                    <app-validation-feedback [control]="type()"
                        [errors]="type().errors"></app-validation-feedback>
                </div>
                }
            </div>

            <!-- Drag and Drop Area -->
            @if(!document().value && !documentID().value) {
            <div class="w-full">
                <input #fileInput type="file" hidden id="file" (change)="onSelect($event)" [disabled]="uploading()">
                <div 
                    class="upload-area border-2 border-dashed rounded-lg p-4 text-center transition-all cursor-pointer"
                    [class.border-blue-500]="isDragging()"
                    [class.bg-blue-50]="isDragging()"
                    [class.border-gray-300]="!isDragging()"
                    [class.hover:border-blue-400]="!isDragging()"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)"
                    (click)="triggerFileInput()">
                    <div class="flex flex-col items-center gap-3">
                        <div class="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center">
                            <i class="pi pi-cloud-upload text-3xl text-blue-600"></i>
                        </div>
                        <div>
                            <p class="text-lg font-semibold text-gray-700 mb-1">
                                Drag and drop your file here
                            </p>
                            <p class="text-sm text-gray-500 mb-3">or</p>
                            <p-button label="Choose File" icon="pi pi-file" 
                                [disabled]="uploading()" 
                                styleClass="bg-blue-600 hover:bg-blue-700 text-white border-0"
                                (onClick)="triggerFileInput(); $event.stopPropagation()"></p-button>
                        </div>
                        <p class="text-xs text-gray-400 mt-1">Supported formats: PDF, DOC, DOCX, XLS, XLSX, etc.</p>
                    </div>
                </div>
            </div>
            } @else {
            <div class="w-full">
                <div class="border border-gray-200 rounded-lg p-4 bg-gray-50">
                    <div class="flex items-center justify-between gap-4">
                        <div class="flex items-center gap-3 flex-1 min-w-0">
                            <div class="w-10 h-10 rounded bg-blue-100 flex items-center justify-center flex-shrink-0">
                                <i class="pi pi-file text-blue-600"></i>
                            </div>
                            <div class="flex-1 min-w-0">
                                <p class="font-medium text-gray-900 truncate" [pTooltip]="document().value?.name ?? documentName().value" tooltipPosition="top">
                                    {{ document().value?.name ?? documentName().value }}
                                </p>
                                <p class="text-sm text-gray-500">File ready to upload</p>
                            </div>
                        </div>
                        <p-button icon="pi pi-times" 
                            styleClass="p-button-text p-button-danger"
                            (onClick)="onRemove()" 
                            [disabled]="uploading()"
                            [pTooltip]="'Remove file'"></p-button>
                    </div>
                </div>
            </div>
            }
        </div>
        
        <!-- Action Buttons at Bottom -->
        <div class="border-t border-gray-200 px-5 py-2 bg-gray-50 flex justify-between gap-3">
            <p-button label="Cancel" 
                icon="pi pi-times" 
                styleClass="p-button-outlined border-gray-300 text-gray-700 hover:bg-gray-100"
                [disabled]="uploading()"
                (onClick)="cancel()"></p-button>
            <p-button label="Upload" 
                icon="pi pi-upload"
                styleClass="bg-blue-600 hover:bg-blue-700 text-white border-0"
                [disabled]="typeID().invalid || uploading() || (!document().value && !documentID().value)"
                (onClick)="handleSave(); $event.stopPropagation()"></p-button>
        </div>
        }
    </div>
    }
    @else {
    @if(dataList.length > 0) {
    <app-view [dataList]="dataList"></app-view>
    }
    }

    }
    <p-toast appendTo="body" />

</div>
